import * as React from 'react';

export const FaqList: React.FC = () => {

  return (
    <>

          <div className="mt-4">
            <h6>
              <a href={`${import.meta.env.BASE_URL}files/videoguides/2. Заполнение анкеты и добавление пользователей.mp4`} target="_blank">Заполнение анкеты и добавление пользователей</a>
            </h6>
            <video width="50%" controls>
              <source src={`${import.meta.env.BASE_URL}files/videoguides/2. Заполнение анкеты и добавление пользователей.mp4`} type="video/mp4"></source>
            </video>
          </div>
          <div className="mt-4">
            <h6>
              <a href={`${import.meta.env.BASE_URL}files/videoguides/3. Уведомления добавленных пользователей КА.mp4`} target="_blank">Уведомления добавленных пользователей КА</a>
            </h6>
            <video width="50%" controls>
              <source src={`${import.meta.env.BASE_URL}files/videoguides/3. Уведомления добавленных пользователей КА.mp4`} type="video/mp4"></source>
            </video>
          </div>
          <div className="mt-4">
            <h6>
              <a href={`${import.meta.env.BASE_URL}files/videoguides/4. Загрузка документации и отправка на согласование.mp4`} target="_blank">Загрузка документации и отправка на согласование</a>
            </h6>
            <video width="50%" controls>
              <source src={`${import.meta.env.BASE_URL}files/videoguides/4. Загрузка документации и отправка на согласование.mp4`} type="video/mp4"></source>
            </video>
          </div>
          <div className="mt-4">
            <h6>
              <a href={`${import.meta.env.BASE_URL}files/videoguides/5. Работа с замечаниями.mp4`} target="_blank">Работа с замечаниями</a>
            </h6>
            <video width="50%" controls>
              <source src={`${import.meta.env.BASE_URL}files/videoguides/5. Работа с замечаниями.mp4`} type="video/mp4"></source>
            </video>
          </div>
          <div className="mt-4">
            <h6>
              <a href={`${import.meta.env.BASE_URL}files/videoguides/6. Утверждение документации.mp4`} target="_blank">Утверждение документации</a>
            </h6>
            <video width="50%" controls>
              <source src={`${import.meta.env.BASE_URL}files/videoguides/6. Утверждение документации.mp4`} type="video/mp4"></source>
            </video>
          </div>

    </>
  );

}